// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Yw8D","options":"AnswerScale_options__5qQyX","selected":"AnswerScale_selected__jf-oD"};